
import { Component, ViewChild } from '@angular/core';
import { BookingInfoProperties, BookingPassengerInfoProperties, RefundTicketProperties, SectorInformationProperties, TaxDetailsProperties } from '../Models/BookingPassengerTicketIssuanceProperties';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Console } from 'console';
import { DatePipe, AsyncPipe } from '@angular/common';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import { AgencyService } from '../Services/Agency.service';
import { AgencyBranchCreditProperties } from '../Models/AgencyMasterProperties';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { empty } from 'rxjs';
import { RevenueManagementService } from '../Services/revenue-management.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { FormsModule } from '@angular/forms';
import { DxDataGridModule } from 'devextreme-angular';
import { DxiColumnModule } from 'devextreme-angular/ui/nested';
@Component({
    selector: 'app-refund-ticket-online',
    templateUrl: './refund-ticket-online.component.html',
    styleUrls: ['./refund-ticket-online.component.css'],
    imports: [NavMenuComponent, FormsModule, DxDataGridModule, DxiColumnModule, AsyncPipe]
})
/** RefundTicketOnline component*/
export class RefundTicketOnlineComponent {
  /** RefundTicketOnline ctor */
  bookingInfoObj = new BookingInfoProperties();

  bookingInfoObjTemp = new BookingInfoProperties();
  creditData: AgencyBranchCreditProperties;
  pendingCreditLimit: number = 0;
  tempPendingCreditLimit: number = 0;
  creditLimit: number = 0;
  sectorInformationListOneWay: SectorInformationProperties[] = [];
  sectorInformationListReturn: SectorInformationProperties[] = [];
  sectorInformationListForMultiCityList: SectorInformationProperties[][] = [];
  sectorInformationReturn: boolean = false;
  sectorInformationMulticity: boolean = false;
  offlineTicketIssue: boolean = false;
  sectorValidation: boolean[] = [];
  loadervisible: boolean = false;
  ngOnDestroy() {
    this.loadervisible = false;
  }
  constructor(public service: TicketIssuanceService, private revenueService: RevenueManagementService,
    private agencyService: AgencyService, private router: Router, private ngbModel: NgbModal) {

  }
  ngOnInit() {

    var obj = JSON.parse(localStorage.getItem("refunddata"));
    let array = [];

    this.bookingInfoObjTemp = obj;
    this.bookingInfoObj = obj;
    for (let j = 0; j < this.bookingInfoObjTemp.bookingPassengerInfoProperties.length; j++) {
      if (this.bookingInfoObjTemp.bookingPassengerInfoProperties[j].isRefund == true || this.bookingInfoObjTemp.bookingPassengerInfoProperties[j].isOfflineRefund == true) {
        if (this.bookingInfoObjTemp.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 0) {
          array.push(this.bookingInfoObjTemp.bookingPassengerInfoProperties[j]);
        }

      }

    }
    this.bookingInfoObj.bookingPassengerInfoProperties = array;
    this.sectorValidation.length = this.bookingInfoObj.bookingPassengerInfoProperties.length;
    this.sectorValidation.fill(false);
    for (let i = 0; i < this.bookingInfoObj.bookingPassengerInfoProperties.length; i++) {
      this.bookingInfoObj.bookingPassengerInfoProperties[i].travelingDate = this.bookingInfoObj.bookingPassengerInfoProperties[i].travelingDate.split('T')[0];
      //new work
      /* let DateFormat = this.bookingInfoObj.bookingPassengerInfoProperties[i].travelingDate;*/

      //let dateDateLong: Date = new Date(DateFormat);
      //let datePipe: DatePipe = new DatePipe('en-UK');
      //this.bookingInfoObj.bookingPassengerInfoProperties[i].travelingDate = (datePipe.transform(dateDateLong, 'dd/MM/yyyy'));

      var passname = `${this.bookingInfoObj.bookingPassengerInfoProperties[i].firstName} ${this.bookingInfoObj.bookingPassengerInfoProperties[i].lastName}`;
      this.bookingInfoObj.bookingPassengerInfoProperties[i].passengerName = passname;
      this.bookingInfoObj.bookingPassengerInfoProperties[i].airlineCode = this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[0].airlineCode;
      this.bookingInfoObj.bookingPassengerInfoProperties[i].refundTicketServiceDetails = new RefundTicketProperties();
    }


    this.getPendingCredit();

  }


  getPendingCredit() {

    let agencyID = this.bookingInfoObjTemp.finalBuyerID;
    // console.log(agencyID);
    /*let branchID = this.bookingInfoObj.finalBuyerID;*/



    if (agencyID) {
      this.agencyService.GetAgencyBranchPendingCreditS(agencyID).subscribe((data) => {
        this.creditData = data;
        if (agencyID.includes('B')) {
          // console.log("i am branch true");
          this.creditLimit = this.creditData.branchInfoProp[0].creditLimit;
          this.pendingCreditLimit = this.creditData.branchInfoProp[0].pendingcreditLimit;
        } else {
          this.creditLimit = this.creditData.agencyMasterProp[0].creditLimit;
          this.pendingCreditLimit = this.creditData.agencyMasterProp[0].pendingcreditLimit;

        }

      })

    }
    //if (branchID) {
    //  this.agencyService.GetAgencyBranchPendingCreditS(branchID).subscribe((data) => {
    //    this.creditData = data;
    //    if (branchID.includes('B')) {
    //      this.creditLimit = this.creditData.branchInfoProp[0].creditLimit;
    //      this.pendingCreditLimit = this.creditData.branchInfoProp[0].pendingcreditLimit;

    //    } else {
    //      this.creditLimit = this.creditData.agencyMasterProp[0].creditLimit;
    //      this.pendingCreditLimit = this.creditData.agencyMasterProp[0].pendingcreditLimit;

    //    }

    //  })
    //}
  }

  CalculateNetAmountRefund(i) {
    var CalculateRFNDAmountbase = document.getElementById(`amountBaserefund${i}`) as HTMLInputElement;
    const ambRFND = CalculateRFNDAmountbase.value;

    var CalculateRFNDService = document.getElementById(`servicechargerefund${i}`) as HTMLInputElement;
    const serviceRFND = CalculateRFNDService.value;

    // var CalculateNETRFND = document.getElementById(`netAmountrefund${i}`) as HTMLInputElement;


    var result = parseInt(ambRFND) - parseInt(serviceRFND);
    var posNum = (result < 0) ? result * -1 : result;
    this.bookingInfoObj.bookingPassengerInfoProperties[i].netRefundAmount = posNum;
  }

  cancelClick() {
    localStorage.removeItem("refunddata");
    this.router.navigateByUrl('/bookingList');
  }
  rejectRefundReq() {
    for (let i = 0; i < this.bookingInfoObj.bookingPassengerInfoProperties.length; i++) {
      this.bookingInfoObj.bookingPassengerInfoProperties[i].isRefund = false;
      this.bookingInfoObj.bookingPassengerInfoProperties[i].isOfflineRefund = false;


    }
    this.service.RejectOfflineRefundRequest(this.bookingInfoObj).subscribe((data) => {
      if (data == true) {
        /*localStorage.setItem("bookingID", JSON.stringify(this.bookingInfoObj.bookingID));*/
        localStorage.removeItem("refunddata");
        this.router.navigateByUrl('/bookingList');
      }
      console.log(data);
    })
  }

  OpenNgbModel = (model) => {
    this.ngbModel.open(model,
      {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'lg'

      }
    )
  }

  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "#f9f9f9", "color": "#212529", "font-weight": "bold" });
  };
  OpenSectorInformationModel = (sectorModel: any, passengerId: Number) => {
    this.sectorInformationListOneWay = [];
    this.sectorInformationListReturn = [];
    this.sectorInformationListForMultiCityList = [];
    for (let i = 0; i < this.bookingInfoObj.bookingPassengerInfoProperties.length; i++) {

      if (passengerId == this.bookingInfoObj.bookingPassengerInfoProperties[i].passengerID) {
        if (this.bookingInfoObj.bookingPassengerInfoProperties[i].sector.includes("OW")) {
          this.sectorInformationReturn = false;
          this.sectorInformationMulticity = false;
          this.sectorInformationListOneWay = this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties;
          break;
        }
        else if (this.bookingInfoObj.bookingPassengerInfoProperties[i].sector.includes("RT")) {
          this.sectorInformationReturn = true;
          this.sectorInformationMulticity = false;
          let sectorFrom: string = this.bookingInfoObj.bookingPassengerInfoProperties[i].sector.split('to')[0].trim();;
          let sectorTo: string = this.bookingInfoObj.bookingPassengerInfoProperties[i].sector.split('to')[1].split(' ')[0];
          let sectorCount = 0;
          for (let j = 0; j < this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; j++) {
            if (this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j].toAirport != sectorTo) {
              this.sectorInformationListOneWay.push(this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j]);
              sectorCount++;
            }
            else {
              if (this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j].toAirport == sectorTo) {
                this.sectorInformationListOneWay.push(this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j]);
                sectorCount++;
                break;
              }
            }
          }
          for (let j = sectorCount; j < this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; j++) {
            if (this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j].toAirport != sectorFrom) {
              this.sectorInformationListReturn.push(this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j]);

            }
            else {
              if (this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j].toAirport == sectorFrom) {
                this.sectorInformationListReturn.push(this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j]);
                break;
              }
            }
          }
          break;
        }
        else if (this.bookingInfoObj.bookingPassengerInfoProperties[i].sector.includes("Offline")) {
          this.offlineTicketIssue = true;
        }
        else {
          this.sectorInformationMulticity = true;
          this.sectorInformationReturn = false;
          let sectorCount = 0;
          for (let j = 0; j < this.bookingInfoObj.galileoBookingProp.flightProp.flightLocationInfo.length; j++) {
            this.sectorInformationListOneWay = []
            for (let k = sectorCount; k < this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; k++) {
              if (this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[k].toAirport
                != this.bookingInfoObj.galileoBookingProp.flightProp.flightLocationInfo[j].toCity) {
                this.sectorInformationListOneWay.push(this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[k]);
                sectorCount++;
              }
              else {
                if (this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[k].toAirport
                  == this.bookingInfoObj.galileoBookingProp.flightProp.flightLocationInfo[j].toCity) {
                  this.sectorInformationListOneWay.push(this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties[k]);
                  sectorCount++;
                  break;
                }
              }
            }
            this.sectorInformationListForMultiCityList.push(this.sectorInformationListOneWay);

          }
        }
      }
    }
    this.OpenNgbModel(sectorModel);
  }
  SectorInformationListOneWayChecked = (event: any) => {
    if (event.target.checked == true) {
      for (let i = 0; i < this.bookingInfoObj.bookingPassengerInfoProperties.length; i++) {
        if (this.bookingInfoObj.bookingPassengerInfoProperties[i].passengerID == this.sectorInformationListOneWay[0].passengerID) {
          this.sectorValidation[i] = true;
          this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties
            = this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties.map(mainSector => {
              const oneWayObj = this.sectorInformationListOneWay.find(oneWay => oneWay.id === mainSector.id);
              if (oneWayObj) {
                return { ...mainSector, isRefunded: true };
              } else {
                return mainSector;
              }
            });
          break;
        }
      }

    }
    if (event.target.checked == false) {
      for (let i = 0; i < this.bookingInfoObj.bookingPassengerInfoProperties.length; i++) {
        if (this.bookingInfoObj.bookingPassengerInfoProperties[i].passengerID == this.sectorInformationListOneWay[0].passengerID) {
          this.sectorValidation[i] = false;
          this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties
            = this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties.map(mainSector => {
              const oneWayObj = this.sectorInformationListOneWay.find(oneWay => oneWay.id === mainSector.id);
              if (oneWayObj) {
                return { ...mainSector, isRefunded: false };
              } else {
                return mainSector;
              }
            });
          break;
        }
      }
    }
  }

  SectorInformationListReturnChecked = (event: any) => {
    if (event.target.checked == true) {
      for (let i = 0; i < this.bookingInfoObj.bookingPassengerInfoProperties.length; i++) {
        if (this.bookingInfoObj.bookingPassengerInfoProperties[i].passengerID == this.sectorInformationListReturn[0].passengerID) {
          this.sectorValidation[i] = true;
          this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties
            = this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties.map(mainSector => {
              const oneWayObj = this.sectorInformationListReturn.find(oneWay => oneWay.id === mainSector.id);
              if (oneWayObj) {
                return { ...mainSector, isRefunded: true };
              } else {
                return mainSector;
              }
            });
          break;
        }
      }

    }
    if (event.target.checked == false) {
      for (let i = 0; i < this.bookingInfoObj.bookingPassengerInfoProperties.length; i++) {
        if (this.bookingInfoObj.bookingPassengerInfoProperties[i].passengerID == this.sectorInformationListReturn[0].passengerID) {
          this.sectorValidation[i] = false;
          this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties
            = this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties.map(mainSector => {
              const oneWayObj = this.sectorInformationListReturn.find(oneWay => oneWay.id === mainSector.id);
              if (oneWayObj) {
                return { ...mainSector, isRefunded: false };
              } else {
                return mainSector;
              }
            });
          break;
        }
      }
    }
  }
  SectorInfomationCancel = (passengerID: number) => {
    this.bookingInfoObj.bookingPassengerInfoProperties.map((passenger, index) => {
      if (passenger.passengerID === passengerID) {
        this.sectorValidation[index] = false;
        return { ...passenger, sectorInformationProperties: passenger.sectorInformationProperties.map(sector => sector.isRefunded = false) };
      }
      return passenger;

    });
    this.ngbModel.dismissAll();
  }
  SectorInformationSave = () => {
    if (this.sectorValidation.length > 0) {
      for (let index = 0; index < this.sectorValidation.length; index++) {
        if (this.sectorValidation[index] == true) {
          this.ngbModel.dismissAll();
          break;
        }
        else {
          document.getElementById('sectorInfomationBtn_Error').innerHTML = "**Please Select Atleast One Sector to Refund!";
          setTimeout(() => {
            document.getElementById('sectorInfomationBtn_Error').innerHTML = "";
          }, 5000)

          return false;
        }
      }
    }
    else {
      document.getElementById('sectorInfomationBtn_Error').innerHTML = "**Please Select Atleast One Sector to Refund!";
      setTimeout(() => {
        document.getElementById('sectorInfomationBtn_Error').innerHTML = "";
      }, 5000)
      return false;
    }

  }
  SectorInformationListMultiCityChecked = (event: any, index: number) => {

    if (event.target.checked == true) {
      for (let i = 0; i < this.bookingInfoObj.bookingPassengerInfoProperties.length; i++) {
        for (let j = 0; j < this.sectorInformationListForMultiCityList[index].length; j++) {
          if (this.bookingInfoObj.bookingPassengerInfoProperties[i].passengerID == this.sectorInformationListForMultiCityList[index][j].passengerID) {
            this.sectorValidation[i] = true;
            this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties
              = this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties.map(multicitySectors => {
                const multiSectors = this.sectorInformationListForMultiCityList[index].filter(sec => sec.id === multicitySectors.id);
                if (multiSectors.length > 0) {

                  return { ...multicitySectors, isRefunded: true }
                }
                else {
                  return multicitySectors;
                }
              });
            console.log(this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties);
            break;
          }

        }


      }
    }
    else {
      if (event.target.checked == false) {
        for (let i = 0; i < this.bookingInfoObj.bookingPassengerInfoProperties.length; i++) {
          for (let j = 0; j < this.sectorInformationListForMultiCityList[index].length; j++) {
            if (this.bookingInfoObj.bookingPassengerInfoProperties[i].passengerID == this.sectorInformationListForMultiCityList[index][j].passengerID) {
              this.sectorValidation[i] = false;
              this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties
                = this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties.map(multicitySectors => {
                  const multiSectors = this.sectorInformationListForMultiCityList[index].filter(sec => sec.id === multicitySectors.id);
                  if (multiSectors.length > 0) {
                    return { ...multicitySectors, isRefunded: false }
                  }
                  else {
                    return multicitySectors;
                  }
                });
              console.log(this.bookingInfoObj.bookingPassengerInfoProperties[i].sectorInformationProperties);
              break;
            }

          }


        }
      }
    }

  }
  SectorSelectionValidation = (): boolean => {
    let success = true;

    if (this.sectorValidation.length > 0) {
      for (let index = 0; index < this.sectorValidation.length; index++) {
        if (this.sectorValidation[index] == false) {
          document.getElementById('lblerrormsgTkt').innerHTML = "**Please Select Atleast One Sector of Each User to Refund!";
          document.getElementById('selectRedundableSector' + index).style.color = "red";
          setTimeout(() => {
            document.getElementById('lblerrormsgTkt').innerHTML = "";
            document.getElementById('selectRedundableSector' + index).style.color = "var(--first-color-second)";
          }, 5000)
          success = false;
          break;

        }
      }

    }
    else {
      document.getElementById('lblerrormsgTkt').innerHTML = "**No Ticket to Refund!";
      setTimeout(() => {
        document.getElementById('lblerrormsgTkt').innerHTML = "";
      }, 5000)
      success = false;
    }
    return success;
  }
  RefundCalculateValue = (index: number): void => {
    this.RefundFareDetailValidations(index);


    this.RefundupdateComm_Off(index);
    this.RefundCalculateVatInput(index);
    this.RefundcalculateCustomerOutput(index);
    this.RefundupdateVenderCharges(index);
    this.RefundupdateSupl_Comm(index);
    this.RefundCalculateVatOutput_of_RFSC(index);
    this.RefundNetFromSupplier(index);
    this.RefundNetToCustomer(index);
    this.RefundUpdateServiceCharges(index);
    this.refundUpdateDiscount(index);
    //this.RefundCalculateProfit(index);

  }
  refundUpdateDiscount = (index: number): void => {
    //this.RefundCalculateProfit(index);
  }
  RefundUpdateServiceCharges = (index: number): void => {
    //this.RefundCalculateProfit(index);
  }
  RefundNetFromSupplier = (index: number): void => {
    var totalcost = 0;
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundFareValue != undefined) {

      totalcost += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundFareValue;

    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundTaxValue != undefined) {


      totalcost += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundTaxValue;
    }

    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges != undefined) {


      totalcost += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges;
    }

    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatInput != undefined) {


      totalcost += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatInput;
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierCommission != undefined) {


      totalcost -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierCommission;
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatOutput != undefined) {

      totalcost -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatOutput;
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundPenality != undefined) {

      totalcost -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundPenality;
    }
    this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.netFromSupplier = Number(totalcost.toFixed(4));
    $("#tbnetFromSupplier").val(totalcost.toFixed(4));
  }
  RefundCalculateVatOutput_of_RFSC = (index: number): void => {
    var cost = 0;
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCharges != undefined || this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationAdditionalServiceCharges != undefined) {

      cost = Number(this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCharges) + Number(this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationAdditionalServiceCharges);

    }

    this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCh_VatOutput = Number(cost.toFixed(4));
    this.RefundCalculateVatOutput(index);
    // this.RefundCalculateProfit(index);
  }
  //RefundCalculateProfit = (index: number): void => {
  // var profit = 0;

  // if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundServiceCharges != undefined) {

  //   profit -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundServiceCharges;

  // }


  // if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundAdditionalServiceCharges != undefined) {

  //   profit -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundAdditionalServiceCharges;

  // }
  // if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierCommission != undefined) {


  //   profit -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierCommission;
  // }

  // if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundDiscount != undefined) {


  //   profit += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundDiscount;
  // }
  // if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCommissionOffer != undefined) {


  //   profit += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCommissionOffer;
  // }
  // if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundProvisionAmount != undefined) {
  //   profit += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundProvisionAmount;
  // }
  // if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundInterBranchCharges != undefined) {
  //   profit += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundInterBranchCharges;
  // }
  // if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCharges != undefined) {

  //   profit += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCharges;
  // }

  // if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationAdditionalServiceCharges != undefined) {

  //   profit += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationAdditionalServiceCharges;
  // }

  // this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundProfit = Number(profit.toFixed(4));
  // }
  RefundupdateSupl_Comm = (index: number): void => {

    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierCommission != undefined) {
      var supp_comm = this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierCommission;
      this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatOutput = supp_comm;
    }
    this.RefundCalculateVatOutput(index);
  }
  RefundupdateVenderCharges = (index: number): void => {
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges != undefined) {
      this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatInput = this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges;
      this.RefundCalculateVatInput(index);
      this.RefundcalculateCustomerOutput(index);
    }

    //this.calculateCustomerOutput();

  }
  RefundcalculateCustomerOutput = (index: number): void => {
    var customerOutput = 0;
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges != undefined) {
      customerOutput += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges;
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundServiceCharges != undefined) {
      customerOutput += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundServiceCharges;
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundAdditionalServiceCharges != undefined) {
      customerOutput += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundAdditionalServiceCharges;
    }

    this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatOutput = customerOutput;
    this.RefundCalculateVatOutput(index);

  }
  RefundCalculateVatOutput = (index: number): void => {
    var vatOnput = 0;
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatOutput != undefined) {
      vatOnput += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatOutput
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatOutput != undefined) {

      vatOnput += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatOutput;
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCh_VatOutput != undefined) {

      vatOnput -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCh_VatOutput;
    }
    this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVatOutput = Number(vatOnput.toFixed(4));
  }
  RefundCalculateVatInput = (index: number): void => {
    var vatInput = 0;
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatInput != undefined) {
      vatInput += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatInput;
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatInput != undefined) {

      vatInput += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierVatInput
    }
    this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVatInput = Number(vatInput.toFixed(4));
  }

  RefundFareDetailValidations = (index: number): boolean => {
    let success = false;
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges > this.bookingInfoObj.bookingPassengerInfoProperties[index].venderServiceCharges || this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges < 0) {

      document.getElementById("lblerrormsgTkt").innerHTML = "RefundVenderServiceCharges is greater VenderServiceCharges";
      document.getElementById("lblerrormsgTkts" + index).innerHTML = "RefundVenderServiceCharges is greater VenderServiceCharges";
      setTimeout(() => {
        document.getElementById('lblerrormsgTkt').innerHTML = "";
        document.getElementById('lblerrormsgTkts' + index).innerHTML = "";
      }, 5000)
      success = false;
    }

    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierCommission > this.bookingInfoObj.bookingPassengerInfoProperties[index].supplierCommission || this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundSupplierCommission < 0) {

      document.getElementById("lblerrormsgTkt").innerHTML = "RefundSupplierCommission is greater than SupplierCommission";
      document.getElementById("lblerrormsgTkts" + index).innerHTML = "RefundSupplierCommission is greater than SupplierCommission";
      setTimeout(() => {
        document.getElementById('lblerrormsgTkt').innerHTML = "";
        document.getElementById('lblerrormsgTkts' + index).innerHTML = "";
      }, 5000)
      success = false;
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundAdditionalServiceCharges > this.bookingInfoObj.bookingPassengerInfoProperties[index].additionalServiceCharges || this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundAdditionalServiceCharges < 0) {

      document.getElementById("lblerrormsgTkt").innerHTML = "refundTicketServiceDetails  AdditionalServiceCharges";
      document.getElementById("lblerrormsgTkts" + index).innerHTML = "refundTicketServiceDetails  AdditionalServiceCharges";
      setTimeout(() => {
        document.getElementById('lblerrormsgTkt').innerHTML = "";
        document.getElementById('lblerrormsgTkts' + index).innerHTML = "";
      }, 5000)
      success = false;
    }

    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCommissionOffer > this.bookingInfoObj.bookingPassengerInfoProperties[index].commissionOffer || this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCommissionOffer < 0) {

      document.getElementById("lblerrormsgTkt").innerHTML = "RefundCommissionOffer is greater than CommissionOffer";
      document.getElementById("lblerrormsgTkts" + index).innerHTML = "RefundCommissionOffer is greater than CommissionOffer";
      setTimeout(() => {
        document.getElementById('lblerrormsgTkt').innerHTML = "";
        document.getElementById('lblerrormsgTkts' + index).innerHTML = "";
      }, 5000)
      success = false;
    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundInterBranchCharges > this.bookingInfoObj.bookingPassengerInfoProperties[index].interBranchCharges || this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundInterBranchCharges < 0) {

      document.getElementById("lblerrormsgTkt").innerHTML = "RefundInterBranchCharges is greater than InterBranchCharges";
      document.getElementById("lblerrormsgTkts" + index).innerHTML = "RefundInterBranchCharges is greater than InterBranchCharges";
      setTimeout(() => {
        document.getElementById('lblerrormsgTkt').innerHTML = "";
        document.getElementById('lblerrormsgTkts' + index).innerHTML = "";
      }, 5000)
      success = false;
    }
    else {
      success = true;
    }
    return success;
  }
  RefundupdateComm_Off = (index: number): void => {
    this.RefundNetToCustomer(index);
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCommissionOffer != undefined) {
      this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatInput = this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCommissionOffer;
    }
  }
  RefundNetToCustomer = (index: number): void => {
    var totalvalue = 0;
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundFareValue != undefined) {

      totalvalue += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundFareValue;

    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundTaxValue != undefined) {

      totalvalue += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundTaxValue;

    }


    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges != undefined) {

      totalvalue += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundVenderServiceCharges;

    }

    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundServiceCharges != undefined) {

      totalvalue += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundServiceCharges;

    }


    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundAdditionalServiceCharges != undefined) {

      totalvalue += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundAdditionalServiceCharges;

    }

    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatOutput != undefined) {

      totalvalue += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatOutput;

    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundPenality != undefined) {

      totalvalue -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundPenality;

    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCommissionOffer != undefined) {

      totalvalue -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCommissionOffer;

    }

    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatInput != undefined) {

      totalvalue -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundCustVatInput;

    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundDiscount != undefined) {

      totalvalue -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundDiscount;

    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCh_VatOutput != undefined) {

      totalvalue -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCh_VatOutput;

    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCharges != undefined) {

      totalvalue -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationServiceCharges;

    }
    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationAdditionalServiceCharges != undefined) {

      totalvalue -= this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundOperationAdditionalServiceCharges;

    }

    if (this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundRoundingDifference != undefined) {
      totalvalue += this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.refundRoundingDifference;
    }
    this.bookingInfoObj.bookingPassengerInfoProperties[index].refundTicketServiceDetails.netToCustomer = Number(totalvalue.toFixed(4));
    $("#tbnetToCustomer").val(totalvalue.toFixed(4));
  }

  approveRefundTkt = () => {
    if (this.SectorSelectionValidation()) {
      this.bookingInfoObj.bookingPassengerInfoProperties.forEach((data, index) => {
        if (this.RefundFareDetailValidations(index) == false) {
          return false;
        }

      })
      this.loadervisible = true;
      this.bookingInfoObj.pendingcredits += this.pendingCreditLimit;
      this.bookingInfoObj.creditslimit = this.creditLimit;
      this.bookingInfoObj.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
      this.bookingInfoObj.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
      this.bookingInfoObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
      this.ApplyRefundRevenue(this.bookingInfoObj);


    }




  }

  ApplyRefundRevenue = (bookingInfoObj: BookingInfoProperties): void => {
    this.revenueService.ApplyRefundRevenue(bookingInfoObj).subscribe(data => {
      this.bookingInfoObj = data;
      this.loadervisible = false;
      if (this.bookingInfoObj.bookingPassengerInfoProperties[0].refundTicketServiceDetails.refundFareValue > 0) {
        this.service.ApproveOfflineRefundRequest(this.bookingInfoObj).subscribe((data) => {
          
          if (data == true) {
            localStorage.setItem("bookingID", JSON.stringify(this.bookingInfoObj.bookingID));
            this.router.navigateByUrl('/ticket-issuance');
            localStorage.removeItem("refunddata");
            this.creditLimit = 0;
            this.pendingCreditLimit = 0;
          }
          console.log(data);
        })
      }
    })

  }

}
